import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    CircularProgress,
    Alert
} from '@mui/material';
import { phoneAuthService } from '../services/phoneAuthService';

interface PhoneVerificationProps {
    verificationId: string;
    onSuccess: () => void;
    onError: (error: string) => void;
}

export const PhoneVerification: React.FC<PhoneVerificationProps> = ({
    verificationId,
    onSuccess,
    onError
}) => {
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            await phoneAuthService.verifyCode(verificationId, code);
            phoneAuthService.clearRecaptcha();
            onSuccess();
        } catch (err: any) {
            setError(err.message);
            onError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <Typography variant="h6" gutterBottom>
                Telefon Doğrulama
            </Typography>
            
            <Typography variant="body2" color="text.secondary" gutterBottom>
                Telefonunuza gönderilen 6 haneli doğrulama kodunu girin.
            </Typography>

            <TextField
                label="Doğrulama Kodu"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                fullWidth
                margin="normal"
                required
                inputProps={{ maxLength: 6 }}
                error={!!error}
                helperText={error}
            />

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                sx={{ mt: 2 }}
                disabled={loading || code.length !== 6}
            >
                {loading ? <CircularProgress size={24} /> : 'Doğrula'}
            </Button>
        </Box>
    );
}; 